import { useEffect } from "react";

export const Modal = ({ isOpen, close, children, style = {} }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "unset";
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = () => {
    close();
  };

  return (
    <>
      <div
        onClick={handleClose}
        className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-40"
      ></div>
      <div
        className="bg-flyers-charcoal border border-flyers-dark-gray p-1 rounded-lg shadow-orange-glow fixed inset-x-0 mx-auto w-full max-w-md top-10 bottom-10 overflow-auto z-50"
        style={style}
      >
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-xl font-bold text-flyers-mid-gray hover:text-flyers-orange transition-colors"
        >
          &times;
        </button>
        {children}
      </div>
    </>
  );
};
